import {
  formatInTimeZone,
  format,
  OptionsWithTZ,
  utcToZonedTime,
} from "date-fns-tz";
import { endOfMonth, startOfDay, startOfMonth } from "date-fns";

const osloTimeZone = "Europe/Oslo";
const timeZoneOffsetFormat = "OOOO";

export const isUserInOsloTimeZone = () => {
  const userDateOffset = format(new Date(), timeZoneOffsetFormat);
  const osloDateOffset = formatInTimeZone(
    new Date(),
    osloTimeZone,
    timeZoneOffsetFormat
  );

  return userDateOffset === osloDateOffset;
};

export const newDateInOsloTimeZone = () => {
  return utcToZonedTime(new Date(), osloTimeZone);
};

